export default {
  actionIcon    : 'StarIcon',
  highlightColor: 'warning',
  data          : [
    {
      index: 0,
      label: 'Inicio',
      url: '/dashboard/ecommerce',
      labelIcon: 'HomeIcon',
      highlightAction: false
    },
    {
      index: 1,
      label: 'Tienda',
      url: '/list/shop-products',
      labelIcon: 'ListIcon',
      highlightAction: false
    },
    {
      index: 2,
      label: 'Mis Estudiantes',
      url: '/students/list',
      labelIcon: 'CheckSquareIcon',
      highlightAction: true
    },
    {
      index: 3,
      label: 'Direcciones',
      url: '/location/mapgrafi',
      labelIcon: 'MessageSquareIcon',
      highlightAction: true
    },
    {
      index: 4,
      label: 'Productos',
      url: '/list/checkout-products',
      labelIcon: 'ListIcon',
      highlightAction: false
    },
  ]
}
